
var OptionsSelectorView = Backbone.Epoxy.View.extend({

  template: 'start-wait-list.optionsSelector',
  bindings: 'data-bind',

  events: {
    'focus #locationInput': function(e) { this.$(e.target).select(); },
  },

  initialize: function() {

  },

  setData: function(data) {

  },

  beforeRender: function() {

  },

  afterRender: function() {
    this.applyBindings();
  },

  cleanup: function() {
    this.removeBindings();
  }

});

module.exports = OptionsSelectorView;